'use client';

import React from 'react';
import { HStack, Skeleton } from '@skin-seoul/design-system';
const TrendingProductSwiperSkeleton = () => {
  const skeletonItems = Array.from({
    length: 3
  }, (_, index) => index);
  return <HStack alignItems="center" height="100%" width="calc(100% - 80px)" display={{
    base: 'none',
    tablet: 'flex',
    desktop: 'flex'
  }} data-sentry-element="HStack" data-sentry-component="TrendingProductSwiperSkeleton" data-sentry-source-file="TrendingProductSwiperSkeleton.tsx">
      {skeletonItems.map(index => <Skeleton display="flex" key={`skeleton-swiper-${index}`} height="358px" flex={1} borderRadius="8px" />)}
    </HStack>;
};
export default TrendingProductSwiperSkeleton;